import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Progress } from "reactstrap";
import Card from "../Card/Card";
import "./DivContent.css";

export default class componentName extends Component {
  renderCard() {
    // console.log(this.props.listjson);
    if (this.props.listjson.length > 0) {
      var json = JSON.parse(this.props.listjson);
      return Object.keys(json).map((value, index) => (
        // console.log(json[value])
        <Link to={"/Port/" + value} key={value}>
          <Card
            key={value}
            title={value}
            content={json[value].description}
            width="300px"
            margin="20px"
            src={json[value].avatar}
          />
        </Link>
      ));
    } else {
      var style = {
        width: "300px",
        display: "inline-block",
        padding: "100px 10px"
      };
      return (
        <div>
          <div style={style}>
            <Progress animated color="info" value="100" />
          </div>
          <div style={style}>
            <Progress animated color="info" value="100" />
          </div>
          <div style={style}>
            <Progress animated color="info" value="100" />
          </div>
        </div>
      );
    }
  }
  render() {
    return (
      <div className="width-divcontent">
        <h1>{this.props.name}</h1>
        {this.renderCard()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DivContent/DivContent.js